import { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import ThemeMaker from "../../components/thememaker";
import { config } from "../../utils/config";
import brandStyles from "../Brand/Brand.module.css";
import styles from "./Rider.module.css";
import "../../components/mcrbTableTheme.css";

const { baseNodeapiUrl } = config;

const PHONE_REGEX = /^[6-9]\d{9}$/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const toastOpts: any = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

const emptyRider = {
    name: "",
    whatsapp_number: "",
    email: "",
    address: "",
};

const AddRider = () => {
    const history = useHistory();
    const [rider, setRider] = useState<any>(emptyRider);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ name: "", whatsapp_number: "", email: "" });

    const fieldChangeHandler = (e: any) => {
        const { name, value } = e.target;
        setRider((prev: any) => ({ ...prev, [name]: value }));
    }

    function fieldErrorFor(name: string, value: string) {
        if (name === "name") {
            return value ? "" : "This field is required !";
        }
        if (name === "whatsapp_number") {
            if (!value) return "This field is required !";
            if (!PHONE_REGEX.test(value)) return "Enter a valid 10-digit mobile number !";
            return "";
        }
        if (name === "email") {
            if (!value) return "";
            if (!EMAIL_REGEX.test(value)) return "Enter a valid email address !";
            return "";
        }
        return "";
    }

    function errorHandler(e: any) {
        const { name, value } = e.target;
        setErrors((prev) => ({ ...prev, [name]: fieldErrorFor(name, value) }));
    }

    function validate() {
        const nextErrors = {
            name: fieldErrorFor("name", rider.name),
            whatsapp_number: fieldErrorFor("whatsapp_number", rider.whatsapp_number),
            email: fieldErrorFor("email", rider.email),
        };
        setErrors(nextErrors);
        return !nextErrors.name && !nextErrors.whatsapp_number && !nextErrors.email;
    }

    const addRiderHandler = async () => {
        if (!validate()) {
            toast.error("Please fix the highlighted fields !", toastOpts);
            return;
        }
        try {
            setLoading(true);
            const { data } = await axios({
                url: `${baseNodeapiUrl}/invlrider/addrider`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: rider
            });

            if (data.success) {
                toast.success("Rider added successfully !", toastOpts);
                history.push('/riderlist');
            } else {
                toast.error(data.message || "Failed to add rider !", toastOpts);
            }
        } catch (error) {
            toast.error("Something went wrong !", toastOpts);
        } finally {
            setLoading(false);
        }
    }

    return (
        <ThemeMaker>
            <div className={`${styles.pageWrap} mcrb-page`}>
                <div className={`${brandStyles.cardOuter} mcrb-card`}>
                    <div className={brandStyles.headerBar}>
                        <span className={brandStyles.title}>Add Rider</span>
                    </div>
                    <div className={brandStyles.bodyArea} style={{ minHeight: "60vh" }}>
                        <div className="row">
                            <div className="col-md-6">
                                <div className={brandStyles.field}>
                                    <label className={brandStyles.label}>Name<span className={brandStyles.required}>*</span>
                                        {errors.name ? <span className={brandStyles.errorInline}>{errors.name}</span> : null}
                                    </label>
                                    <input type="text" className={brandStyles.input} name="name" placeholder="Rider Name"
                                        value={rider.name} onChange={fieldChangeHandler} onBlur={errorHandler} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className={brandStyles.field}>
                                    <label className={brandStyles.label}>WhatsApp Number<span className={brandStyles.required}>*</span>
                                        {errors.whatsapp_number ? <span className={brandStyles.errorInline}>{errors.whatsapp_number}</span> : null}
                                    </label>
                                    <input type="text" className={brandStyles.input} name="whatsapp_number" placeholder="10-digit mobile number"
                                        maxLength={10}
                                        inputMode="numeric"
                                        value={rider.whatsapp_number}
                                        onChange={(e) => {
                                            const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 10);
                                            setRider((prev: any) => ({ ...prev, whatsapp_number: digitsOnly }));
                                        }}
                                        onBlur={errorHandler}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className={brandStyles.field}>
                                    <label className={brandStyles.label}>Email
                                        {errors.email ? <span className={brandStyles.errorInline}>{errors.email}</span> : null}
                                    </label>
                                    <input type="email" className={brandStyles.input} name="email" placeholder="rider@example.com"
                                        value={rider.email} onChange={fieldChangeHandler} onBlur={errorHandler} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className={brandStyles.field}>
                                    <label className={brandStyles.label}>Address</label>
                                    <input type="text" className={brandStyles.input} name="address" placeholder="Address"
                                        value={rider.address} onChange={fieldChangeHandler} />
                                </div>
                            </div>
                            <div className="col-md-12 mt-2">
                                <button type="submit" className={brandStyles.saveBtn} disabled={loading} onClick={addRiderHandler}>
                                    {loading ? "Saving..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ThemeMaker>
    )
}

export default AddRider;
